import Variables from "../features/Variables";

let variables_end = {
    "game": {
        "date": 1623704400000,
        "time": [
            0,
            0
        ],
        "wasStarted": true,
        "nextDayLink": "game.place",
        "day02": {
            "started": true,
            "wentBackAfterHome": true
        },
        randomEvents: {
            courierJob: false,
            homeWife: false
        },
        "home": "apartments01",
        "car": "van",
        "rentPayed": true,
        "currentPlayer": "player",
        "dateWifeTreatedPill": 0,
        "nowIsStory": true,
        morningSetter: null
    },
    "story": {
        "pillForJobEffectBeginsIsShown": true
    },
    "missions": {
        "checkInstruction_01": {
            "started": true,
            "finished": true
        },
        "initCorruption_01": {
            "started": true
        },
        "getInfoAboutDrink_01": {
            "started": true,
            "finished": true
        },
        "buyADrink_01": {
            "started": true,
            "finished": true
        },
        "treatWifePill_01": {
            "started": true,
            "finished": true
        },
        "checkChanges_01": {
            "started": true,
            "finished": true
        },
        "askAtOfficeAboutWife_01": {
            "started": true,
            "finished": true
        },
        "tellWifeAboutJobOps_01": {
            "started": true,
            "finished": true
        },
        "goToInterviewAsWife_01": {
            "started": true
        }
    },
    "player": {
        "name": "Oman",
        "money": 870,
        "debt": -240000,
        "where": "homeBedroom",
        "warnDidntGoToWork": false,
        "things": {},
        schedule: [
            ["homeBathroom", "courier", "courier"],
            ["courier", "courier", "courier"],
            ["homeBedroom", "homeBedroom", "homeBedroom"]
        ]
    },
    "wife": {
        "name": "Alice",
        "nickname": "Al",
        "corruption": 0,
        "appearance": "appearance01",
        appearanceOther: {
            bra: "bra01",
            dress: "jeansAndPullover",
            face: "face01",
            underpants: "underpants01"
        },
        "occupation": {
            "id": "lessons",
            "picture": "/static/media/tired.61882e67108ae9d41341.webp"
        },
        "phone": "01",
        "relations": 70,
        "where": "homeBedroom",
        "messages": {
            "player": [
                "mes01"
            ],
            "wifeMother": [
                "mes01"
            ]
        },
        "newMessage": "",
        "pillsTreated": {
            "pillForJob": true
        },
        schedule: [
            ["wakeup", "shower", "breakfast"],
            ["cook", "clean", "run"],
            ["lessons", "reading", "sleep"]
        ],
        isDressedUp: false
    },
    "town": {
        "name": "Willhem Town"
    },
    "city": {
        "name": "Roll City"
    },
    "pills": {
        "name": "Corwifol"
    }
};

let variables = {
    game: {
        date: new Date('May 31, 2020').getTime(),
        time: [2, 2],
        wasStarted: false,
        nextDayLink: "",
        day02: {
            started: false,
            droveToWork: false,
            wentBackAfterHome: false
        },
        randomEvents: {
            courierJob: false,
            homeWife: false
        },
        home: "initHome",
        car: "oldBMW",
        rentPayed: true,
        currentPlayer: "player",
        dateWifeTreatedPill: 0,
        nowIsStory: true,
        morningSetter: null
    },
    story: {
        pillForJobEffectBeginsIsShown: false
    },
    missions: {},
    player: {
        name: "Michael",
        money: 100,
        debt: -240000,
        where: "",
        warnDidntGoToWork: false,
        things: {},
        schedule: [
            ["homeBathroom", "courier", "courier"],
            ["courier", "courier", "courier"],
            ["homeBedroom", "homeBedroom", "homeBedroom"]
        ]
    },
    wife: {
        name: "Alice",
        nickname: "Al",
        corruption: 0,
        appearance: "appearance01",
        appearanceOther: {
            bra: "bra01",
            dress: "jeansAndPullover",
            face: "face01",
            underpants: "underpants01"
        },
        occupation: {
            id: "",
            picture: ""
        },
        phone: "01",
        relations: 100,
        where: "",
        messages: {
            player: ["mes01"],
            wifeMother: ["mes01"]
        },
        newMessage: "",
        pillsTreated: {},
        schedule: [
            ["wakeup", "shower", "breakfast"],
            ["cook", "clean", "run"],
            ["lessons", "reading", "sleep"]
        ],
        isDressedUp: false
    },
    town: {
        name: "Willhem Town"
    },
    city: {
        name: "Roll City"
    }
};
localStorage.setItem("initVariables", JSON.stringify(variables));

variables = new Variables(variables);

Date.prototype.changeDay = function (days = 0) {
    this.setDate(this.getDate() + days);

    return this.getTime();
}

Date.prototype.getDayName = function() {
    const day = this.getDay();
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    return weekdays[day]
}

Date.prototype.getMonthName = function() {
    const month = this.getMonth();
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    return months[month]
}


export default variables;